/*
 * A three-noun composition shrinks its deepest badge to a few pixels in a data-grid row, so
 * below a threshold the icon renders a shorter chain instead. The switch keys off the icon's
 * own rendered size rather than the `size` prop, because most call sites set no size at all and
 * simply inherit whatever font size their context has.
 */
.container {
    container-type: size;
}

.compact {
    display: none;
}

@container (max-height: 23.9px) {
    .full {
        display: none;
    }

    .compact {
        display: block;
    }
}

/* Without container query support every icon keeps its full chain, which is today's behaviour. */
@supports not (container-type: size) {
    .compact {
        display: none;
    }
}
